import React, { useMemo, useContext } from 'react'
import { Card, FlexView, Spinner } from 'components/common'
import { ResponsiveContainer, PieChart, Pie, Tooltip, Cell } from 'recharts'
import _ from 'lodash'
import { useHistory } from 'react-router-dom'
import { StockContext } from 'stores/StockStore'


const formState = {
  ippn: '',
  client: '',
  center: '',
  sot: '',
  nm: '',
  nmDescription: '',
  materialStatus: '',
  invoice: '',
  warehouse: '',
  reservation:''
}

const COLORS = ['#72aeff', '#3ac5de', '#46c7a8', '#68c17a', '#99b65f', '#ff9661', '#ff8a7e', '#ff87ab', '#f18ee1', '#b19dff']
const RADIAN = Math.PI / 180
const renderCustomizedLabel = ({
  cx, cy, midAngle, innerRadius, outerRadius, percent, index,
}) => {
  const radius = innerRadius + (outerRadius - innerRadius) * 1.1
  const x = cx + radius * Math.cos(-midAngle * RADIAN)
  const y = cy + radius * Math.sin(-midAngle * RADIAN)

  return (
    <text x={x} y={y} fill="black" textAnchor={x> cx ? 'start' : 'end'} dominantBaseline="central" fontSize="14">
      {percent >= 0.03 && `${(percent * 100).toFixed(0)}%`}
    </text>
  )
}

const PiecesPieChartCard = ({ isLoading, pieces, title, ...rest }) => {
  const { getServiceDetailsData } = useContext(StockContext)
  const history = useHistory()
  const totalPieces = useMemo(() => _.sumBy(pieces, 'value'), [pieces])
  const formatTooltip = value => `${value} (${((value / totalPieces) * 100).toFixed(2)}%)`
  
  const onChartClick = (e) => {
    if (title === 'Peças por status do Material') { 
      formState['materialStatus'] = e.name
    } else { 
      formState['client'] = e.name
    }

    getServiceDetailsData(formState)
      .then(history.push("/stock"))
      .catch(error => {
        console.debug(error)
      })
    // console.log(title)
  }

  return <Card style={{ overflow: 'hidden' }} {...rest}>
    <FlexView fontSize="big" fontWeight="bold" margin="0px 0px 16px">{title}</FlexView>
    {isLoading ?
      <FlexView justifyContent="center" alignItems="center" width="100%" height="100%">
        <Spinner />
      </FlexView>
      :
      <ResponsiveContainer width="99%">
        <PieChart>
          <Pie
            data={pieces}
            labelLine={false}
            label={renderCustomizedLabel}
            fill="#8884d8"
            dataKey="value"
            onClick={onChartClick}
            >
            {
              pieces.map((entry, index) => <Cell key={`cell-${index}`} fill={COLORS[index % COLORS.length]} />)
            }
          </Pie>
          <Tooltip formatter={formatTooltip} />
        </PieChart>
      </ResponsiveContainer>
    }
  </Card>
}

export default PiecesPieChartCard